import React from 'react'

export const RisLink = ({ uuid }: {uuid: string}) => {
  if (uuid === '') return null
  const host = process.env.REACT_APP_WEB_HOST || 'https://wwwdev.bodc.ac.uk'
  const formattedUUID = uuid.toUpperCase().replaceAll('-', '')
  return (
    <a href={`${host}/data/published_data_library/ris/${formattedUUID}/`}>
      Cite these data
    </a>
  )
}
